(() => {
  const money = (cents, format) => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    if (format && format.includes('{{amount_no_decimals}}')) return format.replace('{{amount_no_decimals}}', Math.round(Number(cents || 0) / 100));
    if (format && format.includes('{{amount}}')) return format.replace('{{amount}}', value);
    return `$${value}`;
  };

  const liveRegion = document.querySelector('[data-live-region]');
  const announce = (message) => { if (liveRegion) liveRegion.textContent = message; };

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = menu && !menu.classList.contains('is-open');
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
      button.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
    });
  });

  document.querySelectorAll('[data-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const button = document.querySelector('[data-menu-toggle]');
      if (menu) menu.classList.remove('is-open');
      if (button) button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    });
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const media = [...gallery.querySelectorAll('[data-media-id]')];
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.galleryThumb;
        media.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === id));
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantsNode = root.querySelector('[data-variant-json]');
    const select = root.querySelector('[data-variant-select]');
    const button = root.querySelector('[data-add-button]');
    if (!variantsNode || !select) return;
    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      const format = root.dataset.moneyFormat || '${{amount}}';
      root.querySelectorAll('[data-current-price]').forEach((node) => { node.textContent = money(variant.price, format); });
      root.querySelectorAll('[data-compare-price]').forEach((node) => {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        node.classList.toggle('is-hidden', !onSale);
        node.textContent = onSale ? money(variant.compare_at_price, format) : '';
      });
      root.querySelectorAll('[data-save-badge]').forEach((node) => {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        node.classList.toggle('is-hidden', !onSale);
        node.textContent = onSale ? `Save ${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : '';
      });
      if (button) {
        button.disabled = !variant.available;
        button.querySelector('span').textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      announce(`${variant.name || variant.title} selected`);
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = button.dataset.quantityAction === 'increase' ? 1 : -1;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-scroll-to-buy]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('#buy-now');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('[data-add-button]');
      if (button && !button.disabled) {
        button.classList.add('is-loading');
        button.querySelector('span').textContent = 'Adding…';
      }
    });
  });

  const revealItems = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    revealItems.forEach((item) => observer.observe(item));
  }
})();
